import React from 'react'
import { useTranslation } from 'react-i18next'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import { AdsReport } from '../../widgets/ads-report/AdsReport'
import { setModal } from '../../../../app/store/reducers/AppSlice'

interface EditCellProps {
  id: number
  affiliate: string
  ads_count: number
  project_id: number
  network_id: number
  network_name?: string | null
}

export const EditCell = ({
  id,
  affiliate,
  ads_count,
  project_id,
  network_id,
  network_name,
}: EditCellProps) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  return (
    <div className='flex w-full justify-end whitespace-nowrap'>
      <BpButton
        className='w-full'
        size='sm'
        theme='outline'
        onClick={() => {
          dispatch(
            setModal({
              size: 'lg',
              children: (
                <AdsReport
                  adsCount={ads_count}
                  affiliate={affiliate}
                  id={id}
                  networkId={network_id}
                  networkName={network_name}
                  projectId={project_id}
                />
              ),
            }),
          )
        }}
      >
        {t('buttons.sendReport')}
      </BpButton>
    </div>
  )
}
